'use client';

import { BuilderComponent, useIsPreviewing } from '@builder.io/react';
import '@builder.io/widgets';
import { JSX } from 'react';
import { usePublicConfigurationContext } from 'runtime-configuration';

import { BuilderSingleton } from './BuilderSingleton';
import './components/blocks';
import { BuilderPageData, BuilderResponse } from './serverUtils';

//TODO: abstract out builder init to config/secret

export interface BuilderPageProps {
    content: BuilderResponse<BuilderPageData>;
    modelName?: string;
    apiKey?: string | undefined;
    countryCode: string;
    data?: Record<string, unknown>;
}

// Using <Link/> was causing search pages to pre-fetch and trigger extra search events.
// Temporarily removing this until we come up with a long term solution.
// function CustomLink(props: any) {
//     return <Link {...props} />;
// }

export default function RenderBuilderContent({
    content,
    modelName = 'page',
    apiKey,
    countryCode,
    data,
}: BuilderPageProps): JSX.Element | undefined {
    const config = usePublicConfigurationContext();
    const builder = BuilderSingleton.getInstance(apiKey ?? config.builderPublicApiKey);
    const isPreviewing = useIsPreviewing();

    const show404 = !content && !isPreviewing;

    if (!show404) {
        return (
            <BuilderComponent content={content} model={modelName} locale={countryCode} data={data} builder={builder} />
        );
    } else {
        //notFound();
    }
}
